const crearAlerta = (color, mensaje) => {
  return {
    component: {
      template: `
            <div>
                <p>Notificación</p>  
                <strong>${mensaje}</strong>
            </div>
            `
    },
    icon: '',
    horizontalAlign: 'right',
    verticalAlign: 'top',
    type: color
  }
}

export default crearAlerta



// WEBPACK FOOTER //
// ./src/global-services/crearAlerta.js